import { Injectable, Injector } from "@angular/core";
import { I18nService } from "./i18n.service";
import { HttpWrapperService } from "./http.wrapper.service";
import { Router } from "@angular/router";
import { SessionManagerService } from "./SessionManager/session-manager.service";

import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { ITranslations } from "../_models/ITranslations";
import { Observable } from "rxjs/Observable";

@Injectable()
export class TranslationService {
  constructor(
    private i18nService: I18nService,
    private sessionManager: SessionManagerService
  ) {
    this.initTranslations().then();
  }

  private _translations = new BehaviorSubject<ITranslations>(
    // tslint:disable-next-line:no-object-literal-type-assertion
    {} as ITranslations
  );

  public get translations(): Observable<ITranslations> {
    return this._translations.asObservable();
  }
  public get currentTranslations(): ITranslations {
    return this._translations.getValue();
  }

  private async initTranslations() {
    const translationObject =
      (await this.i18nService.getTranslations()) as ITranslations;
    this._translations.next(translationObject);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/translation.service.ts